import { createSchemaDictionary } from '../../schemaToDictionary/createSchemaDictionary';
import { mergeWithSchemaProperty } from './src/mergeWithSchemaProperty';

/**
 * Devuelve la función para mergear el view con su JSONSchema.
 * /!\ Esta función modifica el view original /!\
 *
 * @param {object} schema JSONSchema
 * @param {Object} [options]
 * @param {string} options.name
 * @param {boolean} options.forceMaskNumber
 * @return {Function} el mapper
 */

export function mapSchemaFactory(schema, options) {
  if (typeof schema !== 'object' || !Object.keys(schema).length) {
    return p => p;
  }

  const { name = '', forceMaskNumber = false } = options ?? {};
  const dictionary = createSchemaDictionary(schema);

  return (property, parent) => {
    if (property?.model) {
      const cleanModel = property.model.replace(/\[.*\]/g, ''); // quitamos los [], ej: CAB.LIN[1].REF => CAB.LIN.REF
      const SchemaProperty = dictionary[cleanModel];
      mergeWithSchemaProperty(property, SchemaProperty, { name, forceMaskNumber: forceMaskNumber && parent?.type === 'array' });
    }

    return property;
  };
}
